module.exports = __webpack_public_path__ + "src/assets/img/3_3art_1part.d53bd1a7.jpg";